import LostPasswordModal from './LostPassword'

export default LostPasswordModal
